<p-table [value]="learners" editMode="row" dataKey="index" [responsive]="true">
  <ng-template pTemplate="body" let-learner let-editing="editing" let-ri="rowIndex">
    <tr
      [pEditableRow]="learner"
      [ngClass]="{ 'requires-edit': requireContactMethod && learner.missingContactInformation }"
    >
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <div class="cell-editor-inputs">
              <input
                pInputText
                type="text"
                [(ngModel)]="learner.firstName"
                vnmPlaceholder="add-learners-wizard.first-name"
                required
              />
              <input
                pInputText
                type="text"
                [(ngModel)]="learner.lastName"
                vnmPlaceholder="add-learners-wizard.last-name"
                required
              />
              <input
                pInputText
                type="email"
                [(ngModel)]="learner.email"
                vnmPlaceholder="app.email-placeholder"
                [pattern]="emailPattern"
                [requiredIf]="requireContactMethod && !learner.mobileNumber"
              />
              <p-inputMask
                styleClass="inputfield w-full"
                [placeholder]="'app.phone-placeholder' | translate"
                [(ngModel)]="learner.mobileNumber"
                vnmPlaceholder="app.phone-placeholder"
                mask="(999) 999-9999"
                [requiredIf]="requireContactMethod && !learner.email"
              ></p-inputMask>
            </div>
          </ng-template>
          <ng-template pTemplate="output">
            <span>{{ learner.firstName }} {{ learner.lastName }}</span>
            <vnm-user-contacts [user]="learner"></vnm-user-contacts>
          </ng-template>
        </p-cellEditor>
      </td>

      <td class="cell-editor-actions">
        <div class="inline-flex" [ngClass]="{ 'flex-column': editing, 'flex-row': !editing }">
          <button
            *ngIf="!editing"
            type="button"
            pButton
            pInitEditableRow
            icon="fa fa-fw fa-pencil"
            (click)="onRowEditInit(learner)"
            class="p-button-rounded p-button-text"
          ></button>
          <button
            *ngIf="!editing"
            type="button"
            pButton
            icon="fa fa-fw fa-trash"
            (click)="onRowRemove(learner)"
            class="p-button-rounded p-button-text p-button-danger"
          ></button>
          <button
            *ngIf="editing"
            type="button"
            pButton
            pSaveEditableRow
            icon="fa fa-fw fa-check"
            (click)="onRowEditSave(learner)"
            class="p-button-rounded p-button-text p-button-success"
          ></button>
          <button
            *ngIf="editing"
            type="button"
            pButton
            pCancelEditableRow
            icon="fa fa-fw fa-times"
            (click)="onRowEditCancel(learner)"
            class="p-button-rounded p-button-text p-button-danger"
          ></button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
